import { useEffect, useState } from "react"
import { obterParametrosGerais, salvarParametro } from "../../../services/parametros"
import useAppStore from "../../../stores/AppStore"

function ehVerdadeiro(valor: string) {
    return valor === "true" || valor === "1"
}

export function useParametroPublicoBooleano(nomeParametro: string) {
    const idEstabelecimento = useAppStore(
        s => s.configuracoes?.user?.parametros?.estabelecimento?.id
    )
    const [ativo, setAtivo] = useState(false)
    const [idParametro, setIdParametro] = useState<string | number | null>(null)
    const [carregando, setCarregando] = useState(false)

    useEffect(() => {
        const carregar = async () => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao || !idEstabelecimento) return
            try {
                const response = await obterParametrosGerais(idEstabelecimento, autorizacao)
                if (!response?.retornoErro) {
                    const parametro = (response || []).find((p: any) => p.nome === nomeParametro)
                    if (parametro) {
                        setIdParametro(parametro.id)
                        setAtivo(ehVerdadeiro(parametro.valor))
                    }
                }
            } catch {}
        }
        carregar()
    }, [idEstabelecimento, nomeParametro])

    const alterar = async (novoValor: boolean) => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao || !idEstabelecimento) return
        setCarregando(true)
        try {
            const dados: { id?: string | number; nome: string; valor: string; publico: boolean } = {
                nome: nomeParametro,
                valor: novoValor ? "true" : "false",
                publico: true,
            }
            if (idParametro) dados.id = idParametro

            const response = await salvarParametro(idEstabelecimento, dados, autorizacao)
            if (response?.retornoErro) {
                throw new Error(response.mensagem || "Erro ao salvar parâmetro.")
            }

            setAtivo(novoValor)
            if (response?.id) setIdParametro(response.id)

            const customParams = JSON.parse(localStorage.getItem("custom-params") ?? "{}")
            customParams[nomeParametro] = novoValor
            localStorage.setItem("custom-params", JSON.stringify(customParams))
        } finally {
            setCarregando(false)
        }
    }

    return { ativo, carregando, alterar }
}
